import React, { PureComponent } from 'react'
import {
  TableRow,
  TableCell,
  Typography,
  TableBody,
  LinearProgress
} from '@material-ui/core'

import { BookingsTableRow } from 'components/Bookings/components'
import { allCities } from 'constants/arrays'
import { sortBy } from 'services/helpers'

export class BookingsTableBodyBase extends PureComponent {
  variant = {
    initial: () => {
      const { routeId, date } = this.props

      return (
        <TableRow>
          <TableCell colSpan='10'>
            <Typography variant='subtitle1' align='center'>
              {routeId && date
                ? 'На задану дату і рейс замовлення відсутні'
                : 'Оберіть будь ласка дату і рейс'}
            </Typography>
          </TableCell>
        </TableRow>
      )
    },
    isLoading: () => (
      <TableRow>
        <TableCell colSpan='10'>
          <LinearProgress />
        </TableCell>
      </TableRow>
    ),
    bookings: () => {
      const { order, orderBy, bookings, isFromUaRoute } = this.props

      const citiesCopy = [
        ...allCities
      ]

      const cities = isFromUaRoute
        ? citiesCopy.reverse()
        : citiesCopy

      const sortedBookings = sortBy(bookings, cities, 'from', 'note', 'to')
      const defaultBookings = isFromUaRoute
        ? bookings.sort(this.getSorting(order, orderBy))
        : bookings.sort(this.getSorting(order, orderBy))

      return order === ''
        ? sortedBookings.map(this.renderBookingRow)
        : defaultBookings.map(this.renderBookingRow)
    }
  }

  handlePriceSort = (orderBy, desc) => (a, b) => {
    const bUndefined = b[orderBy] === undefined
    const handler = desc
      ? b[orderBy] - a[orderBy]
      : a[orderBy] - b[orderBy]

    return bUndefined ? -1 : handler
  }

  handleDefSort = (orderBy, desc) => (a, b) => {
    const bUndefined = b[orderBy] === undefined
    const aUndefined = a[orderBy] === undefined

    return bUndefined
      ? -1
      : aUndefined
        ? 1
        : desc
          ? b[orderBy].localeCompare(a[orderBy])
          : a[orderBy].localeCompare(b[orderBy])
  }

  getSorting(order, orderBy) {
    /* eslint-disable */
    switch (orderBy) {
      case 'price':
        return order === 'desc'
          ? this.handlePriceSort(orderBy, true)
          : this.handlePriceSort(orderBy, false)
      default:
        return order === 'desc'
          ? this.handleDefSort(orderBy, true)
          : this.handleDefSort(orderBy, false)
    }
    /* eslint-enable */
  }

  renderBookingRow = (booking, i) => {
    if (booking.status === 'blacklist') {
      return null
    }
    return (
      <BookingsTableRow
        index={i}
        key={booking.id}
        booking={booking}
        from={booking.from}
      />
    )
  }

  render() {
    const { isLoading, bookings } = this.props

    return (
      <TableBody>
        {isLoading
          ? this.variant.isLoading()
          : bookings.length
            ? this.variant.bookings()
            : this.variant.initial()}
      </TableBody>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Bookings/components/BookingsTableBody/BookingsTableBody.js